import {Container, VStack} from '@styled-system/jsx';
import {h1, h2} from '@styled-system/recipes';

const RefundPolicyPage = () => {
  return <Container>
    <VStack p={8} alignItems="flex-start">
      <h1 className={h1()}>
        Fulfillment Policy
      </h1>
      <p>
        Welcome to Fanathem!
      </p>
      <p>
        We are thrilled to offer our customers unique, limited edition collectable merchandise that includes coffee
        mugs,
        gun mats, and high-resolution royalty-free digital downloads. Below you will find our comprehensive fulfillment
        policy designed to ensure a smooth and satisfactory shopping experience for all our valued customers.
      </p>
      <h2 className={h2()}>
        What We Sell
      </h2>
      <p>
        Remarkabl specializes in limited edition collectible merchandise, including coffee mugs, gun mats, and
        high-resolution royalty-free digital downloads. Our products are designed for enthusiasts and collectors who
        value
        quality and exclusivity.
      </p>
      <h2 className={h2()}>
        Purchase Currency
      </h2>
      <p>
        We accept payments in U.S. Dollars (USD) only. Unfortunately, we are unable to accept international currency at
        this time.
      </p>
      <h2 className={h2()}>
        Customer Service Contact Information
      </h2>
      <p>
        Should you need assistance, our customer service team is readily available to help you. You can reach us via:
      </p>
      <ul>
        <li><strong>SMS:</strong> Text START or HELP to 973-577-5771</li>
        <li><strong>Email:</strong> support@fanathem.com</li>
      </ul>
      <h2 className={h2()}>
        Refunds
      </h2>
      <p>
        We do not offer refunds. However, should your merchandise be damaged during shipping, we will provide
        replacement
        items upon receiving photo evidence of the damage.
      </p>
      <h2 className={h2()}>
        Deliveries
      </h2>
      <p>
        Items are shipped via USPS or UPS within 7 business days of purchase. Delivery is through UPS or USPS Ground,
        typically received within 14 days from the date of purchase. Our goods are printed, packed, and shipped from Las
        Vegas, Nevada. All delivery times are based on average in-transit time.
      </p>
      <h2 className={h2()}>
        Returns
      </h2>
      <p>
        We do not accept returns. However, if your items are damaged, you may discard them, and we will ship replacement
        items after we verify the damage through photo evidence. Additional details can be found at our refund policy
        page.
      </p>
      <h2 className={h2()}>
        Cancellations
      </h2>
      <p>
        Customers may cancel subscriptions at any time by logging into their online account.
      </p>
      <h2 className={h2()}>
        Legal or Export Restrictions
      </h2>
      <p>
        Not Applicable.
      </p>
      <h2 className={h2()}>
        Privacy Policy
      </h2>
      <p>
        Your privacy is of utmost importance to us. Please review our privacy policy at our privacy policy page.
      </p>
      <h2 className={h2()}>
        Terms of Use
      </h2>
      <p>
        For information on the use of our website, please visit our terms of use page.
      </p>
      <h2 className={h2()}>
        Promotions, Offer Terms, and Official Rules
      </h2>
      <p>
        For details on promotions and offers, please review our official rules page.
      </p>
      <h2 className={h2()}>
        How to Contact Us by Mail
      </h2>
      <p>
        If you prefer to contact us by mail, please send your correspondence to:
      </p>
      <p>
        55 Madison Ave STE 400
      </p>
      <p>
        Morristown, NJ 07960
      </p>
      <h2 className={h2()}>
        Website Security and Customer Payment Information
      </h2>
      <p>
        The security of your personal information is crucial to us. We use SSL encryption to protect sensitive
        information, such as credit card numbers, submitted to our site. While we strive to use commercially acceptable
        means to protect your personal information, no method is 100% secure. If you have questions about security on
        our
        site, please contact us using the information provided above.
      </p>
      <p>
        Thank you for choosing Remarkabl for your collectible merchandise needs. We are committed to providing you with
        exceptional products and service.
      </p>
    </VStack>
  </Container>
}

export default RefundPolicyPage;
